'use client'
import { WalletConnect } from './walletConnect.js';

const fetchWalletConnectWallets = ({ walletBook, }) => {
    var _a;
    return Object.entries((_a = walletBook === null || walletBook === void 0 ? void 0 : walletBook.wallets) !== null && _a !== void 0 ? _a : {})
        .filter(([, wallet]) => wallet.walletConnect && !wallet.filterFromWalletConnect)
        .map(([key, wallet]) => {
        const { shortName } = wallet;
        const name = shortName || wallet.name;
        return class extends WalletConnect {
            constructor(props) {
                super(Object.assign(Object.assign({}, props), { walletName: name }));
                this.overrideKey = key;
            }
        };
    });
};
const getWalletConnectConnector = () => class extends WalletConnect {
    constructor(props) {
        super(Object.assign(Object.assign({}, props), { walletName: 'WalletConnect' }));
    }
};

export { fetchWalletConnectWallets, getWalletConnectConnector };
